import { defineUi } from '@dashboard/module-contract/ui';
import type { DnsRole } from '../manifest';

export const ui = defineUi<DnsRole>({
	routes: [
		{
			path: '',
			title: 'Zones',
			requiredRole: 'dns:reader',
			component: () => import('./views/zones.vue'),
		},
		{
			/**
			 * One zone, with no nav entry — reached from the list, and by its
			 * URL (`D119`).
			 *
			 * The contract allows this: `assertUiValid` requires every nav
			 * entry to have a route, not the reverse. A detail view has no
			 * place in a nav bar, because there is no single zone to point at.
			 */
			path: 'zones/:zone',
			title: 'Zone',
			requiredRole: 'dns:reader',
			component: () => import('./views/zone.vue'),
		},
		{
			// A page of the module's own, at the path every module's settings
			// use (`D109`) — not a fragment the core's admin page hosts.
			path: 'settings',
			title: 'Settings',
			requiredRole: 'dns:admin',
			component: () => import('./views/settings.vue'),
		},
	],
});
